import { apiFetch } from "./http";
import type { PaymentProvider } from "./api";

export type CheckoutResult = {
  pay_url: string;
  reference: string;
  provider: PaymentProvider;
  currency: string; // fiilen tahsil edilecek para birimi: TRY | USD
  amount_tl?: number;
  amount_usd?: number;
  credits: number;
};

// startCheckout — kredi (doküman) satın alma ödemesini başlatır. credits=kaç doküman
// kredisi alınıyor (anlık satın alma=1, toplu=N). provider ödeme yöntemidir:
// "garanti" TL 3D akışı, "paypal" USD onay akışı. Backend hangi yöntem olursa olsun
// tek bir pay_url döner; frontend bunu popup'ta TOP-LEVEL açar.
export async function startCheckout(
  credits = 1,
  provider: PaymentProvider = "garanti",
): Promise<CheckoutResult> {
  const res = await apiFetch("/api/v1/payments/checkout", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ credits, provider }),
  });
  if (!res.ok) {
    let msg = `HTTP ${res.status}`;
    try { const j = await res.json(); if (j?.error) msg = j.error; } catch { /* ignore */ }
    throw new Error(msg);
  }
  return res.json();
}

// reconcilePayments — PayPal'da onaylayıp ödeme penceresini kapatan kullanıcı için:
// backend org'un bekleyen siparişlerini PayPal'a sorup kapatır. Bekleyen yoksa
// maliyeti tek bir sorgudur. Hata YUTULUR — bu yardımcı bir adımdır, bakiye
// gösterimini bloke etmemeli.
export async function reconcilePayments(): Promise<number> {
  try {
    const res = await apiFetch("/api/v1/payments/reconcile", { method: "POST" });
    if (!res.ok) return 0;
    const j = await res.json();
    return typeof j?.settled === "number" ? j.settled : 0;
  } catch {
    return 0;
  }
}
